import React from 'react';
import './Footer.css';

const quickLinks = [
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Sales', href: '#sales' },
  { label: 'AMC Plans', href: '#amc' },
  { label: 'Contact', href: '#contact' },
];

const servicesList = [
  'Dehumidifier HVAC Systems',
  'Air Handling Units',
  'Compressed Air Dryers',
  'Mould Dehumidification',
  'ODU Servicing',
  'Duct Installation & Fabrication',
];

function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container">
          <div className="row g-5">

            {/* Brand col */}
            <div className="col-lg-4">
              <div className="footer-brand">
                {/* <span className="fb-badge">ATS</span> */}
                <img src="/ATS.jpeg" alt="ATS Logo" className="nav-logo" />
                <span className="fb-name">AIR TECHNO SERVICES</span>
              </div>
              <p className="footer-tagline">
                Reliable · Efficient · Cost-Effective solutions in Dehumidification,
                HVAC, Cleanrooms and Dry Rooms across India.
              </p>
              <div className="footer-contact-mini">
                <div><i className="bi bi-telephone me-2"></i>9964264511 / 8971116369</div>
                <div><i className="bi bi-envelope me-2"></i>airtechnoservices1@gmail.com</div>
                <div><i className="bi bi-geo-alt me-2"></i>Ittamadu, Bengaluru, Karnataka 560085</div>
              </div>
            </div>

            {/* Quick links */}
            <div className="col-sm-6 col-lg-2">
              <h6 className="footer-heading">Quick Links</h6>
              <ul className="footer-links">
                {quickLinks.map(l => (
                  <li key={l.label}>
                    <a href={l.href} onClick={e => scrollTo(e, l.href)}>
                      <i className="bi bi-chevron-right me-1"></i>{l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="col-sm-6 col-lg-3">
              <h6 className="footer-heading">Our Services</h6>
              <ul className="footer-links">
                {servicesList.map(s => (
                  <li key={s}>
                    <a href="#services" onClick={e => scrollTo(e, '#services')}>
                      <i className="bi bi-tools me-1"></i>{s}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* CTA */}
            <div className="col-lg-3">
              <h6 className="footer-heading">Get In Touch</h6>
              <p className="footer-cta-text">Ready to service your equipment or explore an AMC plan?</p>
              <a
                href="#contact"
                className="btn-ats-primary footer-cta-btn"
                onClick={e => scrollTo(e, '#contact')}
              >
                <i className="bi bi-envelope me-2"></i>Send Enquiry
              </a>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="footer-copy">
            © {new Date().getFullYear()} Air Techno Services. All rights reserved.
          </div>
          <div className="footer-built">
            Bengaluru, Karnataka, India
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
